import { useQuery } from '@tanstack/react-query';
import { operationApis } from '../../../../../../../shared/apis/operation/apis';
import { PopupListPayload } from '../../../../../../../shared/apis/operation/types';

export function usePopupList({ queryKey, payload }: { queryKey: string[]; payload: PopupListPayload }) {
  const { data: popupList } = useQuery(queryKey, () => operationApis.getPopupList(payload), {
    select: (data) => data.data,
  });

  return { popupList };
}
